@if (startPoint()){
    <map-marker 
        [position]="startPoint()" 
        [options]="startPointIconOptions" 
    />
}

@for(item of routeSegments(); track item.id; let index = $index; ) {
    <map-marker #markerRef (mapClick)="getMarkerInfo(item)"  />
    @for(relatedItem of item.relatedsItems; track relatedItem.id; ) {
        <map-marker 
            (mapClick)="getRelatedMarkerInfo(relatedItem)"
            [position]="relatedItem.currentLocation"
            [options]="recommendedMarkerOption()"
        />
    }
}